import React from 'react';
import AltIso from 'alt/utils/AltIso';
import _ from 'lodash';

import CompleteProfileHeader from '../components/CompleteProfileHeader';
import CompleteProfileStep1 from '../components/CompleteProfileStep1';
import CompleteProfileStep2 from '../components/CompleteProfileStep2';
import CompleteProfileStep3 from '../components/CompleteProfileStep3';

import SeoActions from '../actions/SeoActions';
import connectToStores from 'alt/utils/connectToStores';

import CurrentUserStore from '../stores/CurrentUserStore';
import ShiftStore from '../stores/ShiftStore';
import PositionStore from '../stores/PositionStore';
import CandidateStore from '../stores/CandidateStore';
import CandidateActions from '../actions/CandidateActions';
import withRouter from '../utils/with-router';
import doRedirect from '../utils/doRedirect';

@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Complete Profile');
            resolve();
        })
    ]);
})
@connectToStores
@withRouter
class CompleteProfile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeStep: 1,
            lastCompletedStep: 1,
            candidateData: {}
        };

        PositionStore.getPositions()
    }

    componentWillReceiveProps() {
        if (this.props.user.profile.profile.is_candidate) {
            doRedirect(this.context.router, 'offers');
        }
    }

    static getPropsFromStores() {
        return {
            shiftStore: ShiftStore.getState(),
            positionStore: PositionStore.getState(),
            candidateStore: CandidateStore.getState(),
            currentUserStore: CurrentUserStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore, PositionStore, CandidateStore, CurrentUserStore];
    }

    shiftHeaderClick(i, force) {
        if (force) this.setState({activeStep: i, lastCompletedStep: i});
        if (i <= this.state.lastCompletedStep) {
            this.setState({
                activeStep: i,
                lastCompletedStep: i > this.state.lastCompletedStep ? i : this.state.lastCompletedStep
            });
        }
    }

    saveProfile(candidateData) {
        let certificates = [];

        candidateData.person_code = candidateData.national_insurance_number || '';
        candidateData.sort_code = candidateData.sort_code || '';

        if ( candidateData.certificates !== null ) {
            candidateData.certificates.forEach(certificate => {
                certificates.push(certificate.file);
            });
        }
        candidateData.ignored_dates = candidateData.dates;

        CandidateStore.saveProfile(null, candidateData);
        doRedirect(this.context.router, 'completeprofilecompleted');
    }

    addData(data, save=false) {
        const candidateData = _.merge({}, this.state.candidateData, data);
        this.setState({candidateData});
        if (save) {
            this.saveProfile(candidateData);
        }
    }

    render() {
        const positions = this.props.positionStore.positions;
        const candidateError = this.props.candidateStore.candidateError;
        const user = this.props.user;

        return (
            <div className="view-complete-profile">
                <CompleteProfileHeader canCancel={this.props.shiftStore.shiftCount > 0} />

                <div className="view-content maxwidth-wrapper">

                    <div className="whitebox">
                        <div className={"complete-profile-step" + (this.state.activeStep == 1 ? " active" : "")}>

                            <button onClick={this.shiftHeaderClick.bind(this, 1, false)} className="complete-profile-step-header">
                                <span className="step-nr">1</span>
                                <h2 className="step-title">My professions</h2>
                            </button>

                            <CompleteProfileStep1 addData={this.addData.bind(this)} mergeErrorsIntoState={CandidateActions.mergeErrorsIntoState} errors={candidateError} positions={positions} changeStep={this.shiftHeaderClick.bind(this)} />
                        </div>

                        <div ref="section-2" className={"complete-profile-step" + (this.state.activeStep == 2 ? " active" : "")}>

                            <button disabled={this.state.lastCompletedStep >= 2 ? false : true} onClick={this.shiftHeaderClick.bind(this, 2, false)} className="complete-profile-step-header">
                                <span className="step-nr">2</span>
                                <h2 className="step-title">My profile</h2>
                            </button>

                            <CompleteProfileStep2 user={user} addData={this.addData.bind(this)} mergeErrorsIntoState={CandidateActions.mergeErrorsIntoState} errors={candidateError} changeStep={this.shiftHeaderClick.bind(this)} />
                        </div>

                        <div className={"complete-profile-step" + (this.state.activeStep == 3 ? " active" : "")}>

                            <button disabled={this.state.lastCompletedStep >= 3 ? false : true} onClick={this.shiftHeaderClick.bind(this, 3, false)} className="complete-profile-step-header">
                                <span className="step-nr">3</span>
                                <h2 className="step-title">My schedule</h2>
                            </button>

                            <CompleteProfileStep3 addData={this.addData.bind(this)} changeStep={this.shiftHeaderClick.bind(this)} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CompleteProfile;



/** WEBPACK FOOTER **
 ** ./app/src/views/CompleteProfile.js
 **/